const courseType = {
  LVT: ['LVT', 'Live Virtual'],
  F2F: ['F2F', 'Classroom'],
  eLearning: ['eLearning', 'E-Learning'],
}

export {courseType}
